import {AUTH_TOKENS} from './modules/di.auth.tokens';
import {CLICKER_GAME_TOKENS} from './modules/di.clicker-game.tokens';
import {DOMAIN_TOKENS} from './modules/di.domain.tokens';
import {GCS_TOKENS} from './modules/di.gcs.tokens';
import {INFRA_TOKENS} from './modules/di.infra.tokens';

export const DI_TOKENS = {
  ...INFRA_TOKENS,
  ...DOMAIN_TOKENS,
  ...AUTH_TOKENS,
  ...GCS_TOKENS,
  ...CLICKER_GAME_TOKENS,
};
